import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { CustomHttpParamsEncoder } from './settings/CustomHttpParamsEncoder';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  public getGemeente(): Observable<any> {
    return this.http.get(this.config.getEndpoint('public/free_projects'));
  }

  public registration(email, ln, projectId): Observable<any> {
    const params = new HttpParams({ encoder: new CustomHttpParamsEncoder() })
      .append('email_address', email)
      .append('language_email', ln)
      .append('project_id', projectId);
    return this.http.post(this.config.getEndpoint('public/add_user_to_free_project'), null, { params });
  }

  public signup(email, password, language): Observable<any> {

    const body = {
      'email': email,
      'password': password,
      'languageEmail': language,
      'baseURL': this.config.getVerificationLink()
    };

    return this.http.post(this.config.getEndpoint('auth/signup/credentials'), body);
  }
}
